import React from "react";
import BestValueTag from "./best-value-tag";
import {BestValue} from "./types";

const EXCLAMATION_IMG_URL = "https://m.media-amazon.com/images/G/01/katara/kyanite/global_assets/icon-error-alert-platinum_20.svg";

export interface TwisterTileProps {
    bestValue?: BestValue;
    header: string;
    subHeader: string;
    showSubHeaderExclamation: boolean;
    price: string;
    priceDetail: string;
    subContent?: string;
    position: string;
    isSelected: boolean;
    onClick: any;
}

const TwisterTile = (props: TwisterTileProps) => {

    return (
        <pui-section class="twister-tile-container" flowdirection="horizontal">
            {props.bestValue && <BestValueTag bestValue={props.bestValue}/>}
            <div className={`twister-tile ${props.position} ${props.isSelected ? 'selected' : ''}`} onClick={props.onClick}>
                <pui-section class="twister-tile-header" flowdirection="vertical" fullwidth>
                    <pui-heading input={props.header} textsize="large" spacingbottom="small"/>
                    <pui-section flowdirection="horizontal" fullwidth>
                        {props.showSubHeaderExclamation && <img src={EXCLAMATION_IMG_URL} className="sub-header-exclamation"/>}
                        <pui-text class="sub-header" input={props.subHeader}/>
                    </pui-section>
                </pui-section>
                <pui-divider/>
                <pui-section class="twister-tile-content" flowdirection="vertical" fullwidth>
                    <pui-section flowdirection="horizontal" spacingbottom="small" secondaryaxisarrangement="baseline" fullwidth>
                        <pui-text class="price" input={props.price} variant="price" textsize="double-extra-large" fontweight="bold"/>
                        <pui-text class="price-detail" input={props.priceDetail} textsize="medium"/>
                    </pui-section>
                    {!!props.subContent && <pui-text class="sub-content" input={props.subContent} textsize="medium"/>}
                </pui-section>
            </div>
        </pui-section>
    )
}

export default TwisterTile;